angular.module('unica_hotel.hotel_controllers', []);
